import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-unable",
  "use": "icon-unable-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-unable\">\n    <!-- Generator: Sketch 53.2 (72643) - https://sketchapp.com -->\n    <title>icon24/unable</title>\n    <desc>Created with Sketch.</desc>\n    <g id=\"icon-unable_icon24-symbols\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <g id=\"icon-unable_icon24/unable\">\n            <circle id=\"icon-unable_Oval\" fill=\"#DCDCDC\" cx=\"12\" cy=\"12\" r=\"9\" />\n            <circle id=\"icon-unable_Oval\" fill=\"#E5E5E5\" cx=\"12\" cy=\"12\" r=\"8\" />\n        </g>\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/unable.svg
// module id = Gouh
// module chunks = 54